import { Link } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { ROUTE_PATHS } from 'routes';
import { ReactComponent as LogoSvg } from 'assets/img/crosswalk-logo.svg';

export default function Logo() {
  return (
    <Link component={NavLink} to={ROUTE_PATHS.DEFAULT}>
      <LogoSvg />
    </Link>
  );
}
